import { useQuery, useQueryClient } from '@tanstack/react-query'
import { emailServiceApi } from '../api/emailServiceApi'

export default function useEmailServiceStatusQuery() {
  const queryClient = useQueryClient()
  const queryKey = ['email-service-status']
  const query = useQuery({
    queryKey,
    queryFn: emailServiceApi.getStatus,
    refetchInterval: 300000, // 5 minutes
    refetchOnWindowFocus: true,
    retry: 3,
    retryDelay: 5000,
  })

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey })
  }

  return { ...query, invalidate }
}
